<template>
	<div>
		<div class="box">
		    <h2 class="match-header">Reference: {{title | capitalize}}</h2>
            <div class="configuration-reference">
				<md-card-content class="card-content">
				<div class="row" v-if="$route.params.reference != 'interests' && $route.params.reference != 'wizard-content'">
					<div class="col-sm-8">
						<div class="button-section button-section-style">
							<md-button class="md-raised md-accent md-white-color capitalize" :disabled="disabledBtn == 1 ? true : false">
								<md-dialog-confirm
							  	:md-active.sync="allDeleteBtn"
							  	md-title="Delete Confirmation"
							  	:md-content="setContentForAllDelete"
							  	@md-confirm="removeAllRecord" />
								<span class="md-remove md-remove-all" @click="allDeleteBtn = true">Delete All</span>
							</md-button>
							<md-button class="md-raised md-accent md-white-color capitalize" :disabled="disabled == 1 ? true : false">
								<md-dialog-confirm
							  	:md-active.sync="active"
							  	md-title="Delete Confirmation"
							  	:md-content="setContent"
							  	@md-confirm="removeRecord" />
								<span class="md-remove" @click="active = true">Delete</span>
							</md-button>
							<md-button class="md-raised md-accent md-white-color capitalize" v-if="$route.params.reference != 'protopia-owner' && $route.params.reference != 'wizard-content'"  @click="$refs.file.click()">Load</md-button>
							<md-button class="md-raised md-accent md-white-color capitalize" @click="AddNewFilter()" v-if="$route.params.reference == 'filter-words' || $route.params.reference == 'protopia-owner' || $route.params.reference == 'wizard-content' ">Add New</md-button>
							<a target="_blank" v-bind:href="CSVLink" v-if="$route.params.reference != 'protopia-owner' && $route.params.reference != 'wizard-content'" title="Download sample file" download>
								<md-button class="md-fab md-mini md-white-color downloadBtn">
									<i class="fa fa-download"></i>
								</md-button>
							</a>
						</div>
						<p style="color:#ff0000" v-if="$route.params.reference != 'protopia-owner' && $route.params.reference != 'wizard-content'"> Note : Please upload maximum 5,000 record in single upload! </p>
					</div>
					<div class="col-sm-4">
						<md-field>
							<md-input v-model.trim="searchData" @input="sanitizeSearchData" @keyup="searchDataFromList" name="searchData" placeholder="Search..."></md-input>
					    </md-field>
					</div>
				</div>
					<!-- Education -->
					<md-table class="education-table" v-if="$route.params.reference == 'education'">
						<md-table-row >
							<md-table-head class="card-header">
								<md-checkbox class="checkBox-visible" v-model="checkAll" :value="true" @change="checkAllData()"></md-checkbox>
							</md-table-head>
							<md-table-head class="card-header">
								Country
								<img src="https://storage.googleapis.com/protopia/app/web/down-arrow.png" v-if="countrySort === 'desc'" @click="sortColumn('asc','country')">
								<img src="https://storage.googleapis.com/protopia/app/web/up-arrow.png" v-if="countrySort === 'asc'" @click="sortColumn('desc','country')">
							</md-table-head>
							<md-table-head class="card-header">College
								<img src="https://storage.googleapis.com/protopia/app/web/down-arrow.png" v-if="collegeSort === 'desc'" @click="sortColumn('asc','college')">
								<img src="https://storage.googleapis.com/protopia/app/web/up-arrow.png" v-if="collegeSort === 'asc'" @click="sortColumn('desc','college')">
							</md-table-head>
							<md-table-head class="card-header">
								City
								<img src="https://storage.googleapis.com/protopia/app/web/down-arrow.png" v-if="citySort === 'desc'" @click="sortColumn('asc','city')">
								<img src="https://storage.googleapis.com/protopia/app/web/up-arrow.png" v-if="citySort === 'asc'" @click="sortColumn('desc','city')">
							</md-table-head>
							<md-table-head class="card-header">
								State
								<img src="https://storage.googleapis.com/protopia/app/web/down-arrow.png" v-if="stateSort === 'desc'" @click="sortColumn('asc','state')">
								<img src="https://storage.googleapis.com/protopia/app/web/up-arrow.png" v-if="stateSort === 'asc'" @click="sortColumn('desc','state')">
							</md-table-head>
							<md-table-head class="card-header"> Action </md-table-head>
						</md-table-row>
						<template v-for="(referenceData) in configurationData">
							<tr class="md-table-row" v-bind:key="referenceData._id">
								<td class="md-table-cell">
									<div class="md-table-cell-container"><md-checkbox v-model="singleCheckBox" @change="singleRowCheck()" :value="referenceData._id"></md-checkbox></div>
								</td>
								<td class="md-table-cell"><div class="md-table-cell-container">{{ referenceData.country ? referenceData.country: '-'}}</div></td>
								<td class="md-table-cell"><div class="md-table-cell-container">{{ referenceData.college ? referenceData.college: '-'}}</div></td>
								<td class="md-table-cell"><div class="md-table-cell-container">{{ referenceData.city ? referenceData.city: '-'}}</div></td>
								<td class="md-table-cell"><div class="md-table-cell-container">{{ referenceData.state ? referenceData.state: '-'}}</div></td>
								<td class="md-table-cell">
									<div class="md-table-cell-container"><router-link :to="{ path: 'reference-' + $route.params.reference + '/' + referenceData._id + '/edit', params: { reference: $route.params.reference, id: referenceData._id }}" ><i class="fa fa-edit"></i></router-link></div>
								</td>
							</tr>
						</template>
						<template v-if="configurationData.length == 0">
							<tr>
								<td colspan="6" align="center">
									<md-empty-state
									  class="table-no-record"
							          md-label="No Record Found"
							          md-description="">
							        </md-empty-state>
								</td>
							</tr>
						</template>
					</md-table>

					<!-- Location -->
					<md-table class="location-table" v-if="$route.params.reference == 'location'">
						<md-table-row >
							<md-table-head class="card-header">
								<md-checkbox class="checkBox-visible" v-model="checkAll" :value="true" @change="checkAllData()"></md-checkbox>
							</md-table-head>
							<md-table-head class="card-header">
								Country
								<img src="https://storage.googleapis.com/protopia/app/web/down-arrow.png" v-if="countrySort === 'desc'" @click="sortColumn('asc','country')">
								<img src="https://storage.googleapis.com/protopia/app/web/up-arrow.png" v-if="countrySort === 'asc'" @click="sortColumn('desc','country')">
							</md-table-head>
							<md-table-head class="card-header">
								State
								<img src="https://storage.googleapis.com/protopia/app/web/down-arrow.png" v-if="stateSort === 'desc'" @click="sortColumn('asc','state')">
								<img src="https://storage.googleapis.com/protopia/app/web/up-arrow.png" v-if="stateSort === 'asc'" @click="sortColumn('desc','state')">
							</md-table-head>
							<md-table-head class="card-header">
								City
								<img src="https://storage.googleapis.com/protopia/app/web/down-arrow.png" v-if="citySort === 'desc'" @click="sortColumn('asc','city')">
								<img src="https://storage.googleapis.com/protopia/app/web/up-arrow.png" v-if="citySort === 'asc'" @click="sortColumn('desc','city')">
							</md-table-head>
							<md-table-head class="card-header">Latitude
								<img src="https://storage.googleapis.com/protopia/app/web/down-arrow.png" v-if="latitudeSort === 'desc'" @click="sortColumn('asc','latitude')">
								<img src="https://storage.googleapis.com/protopia/app/web/up-arrow.png" v-if="latitudeSort === 'asc'" @click="sortColumn('desc','latitude')">
							</md-table-head>
							<md-table-head class="card-header">Longitude
								<img src="https://storage.googleapis.com/protopia/app/web/down-arrow.png" v-if="longitudeSort === 'desc'" @click="sortColumn('asc','longitude')">
								<img src="https://storage.googleapis.com/protopia/app/web/up-arrow.png" v-if="longitudeSort === 'asc'" @click="sortColumn('desc','longitude')">
							</md-table-head>
							<md-table-head class="card-header">Population
								<img src="https://storage.googleapis.com/protopia/app/web/down-arrow.png" v-if="populationSort === 'desc'" @click="sortColumn('asc','population')">
								<img src="https://storage.googleapis.com/protopia/app/web/up-arrow.png" v-if="populationSort === 'asc'" @click="sortColumn('desc','population')">
							</md-table-head>
							<md-table-head class="card-header"> Action </md-table-head>
						</md-table-row>
						<template v-for="(referenceData) in configurationData">
							<tr class="md-table-row" v-bind:key="referenceData._id">
								<td class="md-table-cell">
									<div class="md-table-cell-container"><md-checkbox v-model="singleCheckBox" @change="singleRowCheck()" :value="referenceData._id"></md-checkbox></div>
								</td>
								<td class="md-table-cell"><div class="md-table-cell-container">{{ referenceData.country? referenceData.country: '-'}}</div></td>
								<td class="md-table-cell"><div class="md-table-cell-container">{{ referenceData.state ? referenceData.state: '-'}}</div></td>
								<td class="md-table-cell"><div class="md-table-cell-container">{{ referenceData.city ? referenceData.city: '-'}}</div></td>
								<td class="md-table-cell"><div class="md-table-cell-container">{{ referenceData.latitude ? referenceData.latitude: '-'}}</div></td>
								<td class="md-table-cell"><div class="md-table-cell-container">{{ referenceData.longitude ? referenceData.longitude: '-'}}</div></td>
								<td class="md-table-cell"><div class="md-table-cell-container">{{ referenceData.population ? referenceData.population: '-'}}</div></td>
								<td class="md-table-cell">
									<div class="md-table-cell-container"><router-link :to="{ path: 'reference-' + $route.params.reference + '/' + referenceData._id + '/edit', params: { reference: $route.params.reference, id: referenceData._id }}" ><i class="fa fa-edit"></i></router-link></div>
								</td>
							</tr>
						</template>
						<template v-if="configurationData.length == 0">
							<tr>
								<td colspan="8" align="center">
									<md-empty-state
									  class="table-no-record"
							          md-label="No Record Found"
							          md-description="">
							        </md-empty-state>
								</td>
							</tr>
						</template>
					</md-table>

					<!-- organization -->
					<md-table class="organization-table" v-if="$route.params.reference == 'organization'">
						<md-table-row >
							<md-table-head class="card-header">
								<md-checkbox class="checkBox-visible" v-model="checkAll" :value="true" @change="checkAllData()"></md-checkbox>
							</md-table-head>
							<md-table-head class="card-header">Name
								<img src="https://storage.googleapis.com/protopia/app/web/down-arrow.png" v-if="nameSort === 'desc'" @click="sortColumn('asc','name')">
								<img src="https://storage.googleapis.com/protopia/app/web/up-arrow.png" v-if="nameSort === 'asc'" @click="sortColumn('desc','name')">
							</md-table-head>
							<md-table-head class="card-header">
								URL
								<img src="https://storage.googleapis.com/protopia/app/web/down-arrow.png" v-if="urlSort === 'desc'" @click="sortColumn('asc','url')">
								<img src="https://storage.googleapis.com/protopia/app/web/up-arrow.png" v-if="urlSort === 'asc'" @click="sortColumn('desc','url')">
							</md-table-head>
							<md-table-head class="card-header">
								Category
								<img src="https://storage.googleapis.com/protopia/app/web/down-arrow.png" v-if="categorySort === 'desc'" @click="sortColumn('asc','category')">
								<img src="https://storage.googleapis.com/protopia/app/web/up-arrow.png" v-if="categorySort === 'asc'" @click="sortColumn('desc','category')">
							</md-table-head>
							<md-table-head class="card-header">
								Market
								<img src="https://storage.googleapis.com/protopia/app/web/down-arrow.png" v-if="marketSort === 'desc'" @click="sortColumn('asc','market')">
								<img src="https://storage.googleapis.com/protopia/app/web/up-arrow.png" v-if="marketSort === 'asc'" @click="sortColumn('desc','market')">
							</md-table-head>
							<md-table-head class="card-header">
								Status
								<img src="https://storage.googleapis.com/protopia/app/web/down-arrow.png" v-if="statusSort === 'desc'" @click="sortColumn('asc','status')">
								<img src="https://storage.googleapis.com/protopia/app/web/up-arrow.png" v-if="statusSort === 'asc'" @click="sortColumn('desc','status')">
							</md-table-head>
							<md-table-head class="card-header">
								Country
								<img src="https://storage.googleapis.com/protopia/app/web/down-arrow.png" v-if="countrySort === 'desc'" @click="sortColumn('asc','country')">
								<img src="https://storage.googleapis.com/protopia/app/web/up-arrow.png" v-if="countrySort === 'asc'" @click="sortColumn('desc','country')">
							</md-table-head>
							<md-table-head class="card-header">
								Region
								<img src="https://storage.googleapis.com/protopia/app/web/down-arrow.png" v-if="regionSort === 'desc'" @click="sortColumn('asc','region')">
								<img src="https://storage.googleapis.com/protopia/app/web/up-arrow.png" v-if="regionSort === 'asc'" @click="sortColumn('desc','region')">
							</md-table-head>
							<md-table-head class="card-header">
								City
								<img src="https://storage.googleapis.com/protopia/app/web/down-arrow.png" v-if="citySort === 'desc'" @click="sortColumn('asc','city')">
								<img src="https://storage.googleapis.com/protopia/app/web/up-arrow.png" v-if="citySort === 'asc'" @click="sortColumn('desc','city')">
							</md-table-head>
							<md-table-head class="card-header">
								State
								<img src="https://storage.googleapis.com/protopia/app/web/down-arrow.png" v-if="stateSort === 'desc'" @click="sortColumn('asc','state')">
								<img src="https://storage.googleapis.com/protopia/app/web/up-arrow.png" v-if="stateSort === 'asc'" @click="sortColumn('desc','state')">
							</md-table-head>
							<md-table-head class="card-header"> Action </md-table-head>
						</md-table-row>
						<template v-for="(referenceData) in configurationData">
							<tr class="md-table-row" v-bind:key="referenceData._id">
								<td class="md-table-cell">
									<div class="md-table-cell-container"><md-checkbox v-model="singleCheckBox" @change="singleRowCheck()" :value="referenceData._id"></md-checkbox></div>
								</td>
								<td class="md-table-cell"><div class="md-table-cell-container">{{ referenceData.name ? referenceData.name: '-'}}</div></td>
								<td class="md-table-cell"><div class="md-table-cell-container">{{ referenceData.url ? referenceData.url: '-'}}</div></td>
								<td class="md-table-cell"><div class="md-table-cell-container">{{ displayCategory(referenceData.category) }}</div></td>
								<td class="md-table-cell"><div class="md-table-cell-container">{{ referenceData.market ? referenceData.market: '-'}}</div></td>
								<td class="md-table-cell"><div class="md-table-cell-container">{{ referenceData.status ? referenceData.status: '-'}}</div></td>
								<td class="md-table-cell"><div class="md-table-cell-container">{{ referenceData.country ? referenceData.country: '-'}}</div></td>
								<td class="md-table-cell"><div class="md-table-cell-container">{{ referenceData.state ? referenceData.state: '-'}}</div></td>
								<td class="md-table-cell"><div class="md-table-cell-container">{{ referenceData.region ? referenceData.region: '-'}}</div></td>
								<td class="md-table-cell"><div class="md-table-cell-container">{{ referenceData.city ? referenceData.city: '-'}}</div></td>
								<td class="md-table-cell">
									<div class="md-table-cell-container"><router-link :to="{ path: 'reference-' + $route.params.reference + '/' + referenceData._id + '/edit', params: { reference: $route.params.reference, id: referenceData._id }}" ><i class="fa fa-edit"></i></router-link></div>
								</td>
							</tr>
						</template>
						<template v-if="configurationData.length == 0">
							<tr>
								<td colspan="11" align="center">
									<md-empty-state
									  class="table-no-record"
							          md-label="No Record Found"
							          md-description="">
							        </md-empty-state>
								</td>
							</tr>
						</template>
					</md-table>

					<!-- Role -->
					<md-table class="roles-table" v-if="$route.params.reference == 'roles'">
						<md-table-row >
							<md-table-head class="card-header">
								<md-checkbox class="checkBox-visible" v-model="checkAll" :value="true" @change="checkAllData()"></md-checkbox>
							</md-table-head>
							<md-table-head class="card-header">Role
								<img src="https://storage.googleapis.com/protopia/app/web/down-arrow.png" v-if="roleSort === 'desc'" @click="sortColumn('asc','role')">
								<img src="https://storage.googleapis.com/protopia/app/web/up-arrow.png" v-if="roleSort === 'asc'" @click="sortColumn('desc','role')">
							</md-table-head>
							<md-table-head class="card-header">
								Description
								<img src="https://storage.googleapis.com/protopia/app/web/down-arrow.png" v-if="descriptionSort === 'desc'" @click="sortColumn('asc','description')">
								<img src="https://storage.googleapis.com/protopia/app/web/up-arrow.png" v-if="descriptionSort === 'asc'" @click="sortColumn('desc','description')">
							</md-table-head>
							<md-table-head class="card-header"> Action </md-table-head>
						</md-table-row>
						<template v-for="(referenceData) in configurationData">
							<tr class="md-table-row" v-bind:key="referenceData._id">
								<td class="md-table-cell">
									<div class="md-table-cell-container"><md-checkbox v-model="singleCheckBox" @change="singleRowCheck()" :value="referenceData._id"></md-checkbox></div>
								</td>
								<td class="md-table-cell"><div class="md-table-cell-container">{{ referenceData.role  ? referenceData.role: '-'}}</div></td>
								<td class="md-table-cell"><div class="md-table-cell-container">{{ referenceData.description ? referenceData.description: '-'}}</div></td>
								<td class="md-table-cell">
									<div class="md-table-cell-container"><router-link :to="{ path: 'reference-' + $route.params.reference + '/' + referenceData._id + '/edit', params: { reference: $route.params.reference, id: referenceData._id }}" ><i class="fa fa-edit"></i></router-link></div>
								</td>
							</tr>
						</template>
						<template v-if="configurationData.length == 0">
							<tr>
								<td colspan="4" align="center">
									<md-empty-state
									  class="table-no-record"
							          md-label="No Record Found"
							          md-description="">
							        </md-empty-state>
								</td>
							</tr>
						</template>
					</md-table>

					<!--Coaching templates-->
					<md-table class="coaching-templates-table" v-if="$route.params.reference == 'coaching-templates'">
						<md-table-row>
							<md-table-head class="card-header">
								<md-checkbox class="checkBox-visible" v-model="checkAll" :value="true" @change="checkAllData()"></md-checkbox>
							</md-table-head>
							<md-table-head class="card-header">Title</md-table-head>
							<md-table-head class="card-header">Content</md-table-head>
							<md-table-head class="card-header">Action</md-table-head>
						</md-table-row>
						<template v-for="(referenceData) in filteredCoachingTemplates">
							<tr class="md-table-row" v-bind:key="referenceData._id">
								<td class="md-table-cell">
									<div class="md-table-cell-container">
										<md-checkbox v-model="singleCheckBox" @change="singleRowCheck()" :value="referenceData._id"></md-checkbox>
									</div>
								</td>
								<td class="md-table-cell">
									<div class="md-table-cell-container">{{ referenceData.name ? referenceData.name : '-' }}</div>
								</td>
								<td class="md-table-cell">
									<div class="md-table-cell-container">{{ referenceData.content ? referenceData.content : '-' }}</div>
								</td>
								<td class="md-table-cell">
									<div class="md-table-cell-container">
										<router-link :to="{ path: 'reference-' + $route.params.reference + '/' + referenceData._id + '/edit', params: { reference: $route.params.reference, id: referenceData._id } }">
											<i class="fa fa-edit"></i>
										</router-link>
									</div>
								</td>
							</tr>
						</template>
						<template v-if="configurationData.length == 0">
							<tr>
								<td colspan="6" align="center">
									<md-empty-state
										class="table-no-record"
										md-label="No Record Found"
										md-description="">
									</md-empty-state>
								</td>
							</tr>
						</template>
					</md-table>
					<!-- Skills -->
					<md-table class="member-table" v-if="$route.params.reference == 'skills'">
						<md-table-row >
							<md-table-head class="card-header">
								<md-checkbox class="checkBox-visible" v-model="checkAll" :value="true" @change="checkAllData()"></md-checkbox>
							</md-table-head>
							<md-table-head class="card-header">Skills
								<img src="https://storage.googleapis.com/protopia/app/web/down-arrow.png" v-if="skillsSort === 'desc'" @click="sortColumn('asc','skills')">
								<img src="https://storage.googleapis.com/protopia/app/web/up-arrow.png" v-if="skillsSort === 'asc'" @click="sortColumn('desc','skills')">
							</md-table-head>
							<md-table-head class="card-header"> Action </md-table-head>
						</md-table-row>
						<template v-for="(referenceData) in configurationData">
							<tr class="md-table-row" v-bind:key="referenceData._id">
								<td class="md-table-cell">
									<div class="md-table-cell-container"><md-checkbox v-model="singleCheckBox" @change="singleRowCheck()" :value="referenceData._id"></md-checkbox></div>
								</td>
								<td class="md-table-cell"><div class="md-table-cell-container">{{ referenceData.skills ? referenceData.skills: '-'}}</div></td>
								<td class="md-table-cell">
									<div class="md-table-cell-container"><router-link :to="{ path: 'reference-' + $route.params.reference + '/' + referenceData._id + '/edit', params: { reference: $route.params.reference, id: referenceData._id }}" ><i class="fa fa-edit"></i></router-link></div>
								</td>
							</tr>
						</template>
						<template v-if="configurationData.length == 0">
							<tr>
								<td colspan="3" align="center">
									<md-empty-state
									  class="table-no-record"
							          md-label="No Record Found"
							          md-description="">
							        </md-empty-state>
								</td>
							</tr>
						</template>
					</md-table>

					<!-- Filter Words -->
					<md-table class="member-table" v-if="$route.params.reference == 'filter-words'">
						<md-table-row >
							<md-table-head class="card-header">
								<md-checkbox class="checkBox-visible" v-model="checkAll" :value="true" @change="checkAllData()"></md-checkbox>
							</md-table-head>
							<md-table-head class="card-header">Filter Words
								<img src="https://storage.googleapis.com/protopia/app/web/down-arrow.png" v-if="wordSort === 'desc'" @click="sortColumn('asc','word')">
								<img src="https://storage.googleapis.com/protopia/app/web/up-arrow.png" v-if="wordSort === 'asc'" @click="sortColumn('desc','word')">
							</md-table-head>
							<md-table-head class="card-header"> Action </md-table-head>
						</md-table-row>
						<template v-for="(referenceData) in configurationData">
							<tr class="md-table-row" v-bind:key="referenceData._id">
								<td class="md-table-cell">
									<div class="md-table-cell-container"><md-checkbox v-model="singleCheckBox" @change="singleRowCheck()" :value="referenceData._id"></md-checkbox></div>
								</td>
								<td class="md-table-cell"><div class="md-table-cell-container">{{ referenceData.word ? changeTxt(referenceData.word): '-' }}</div></td>
								<td class="md-table-cell">
									<div class="md-table-cell-container"><router-link :to="{ path: 'reference-' + $route.params.reference + '/' + referenceData._id + '/edit', params: { reference: $route.params.reference, id: referenceData._id }}" ><i class="fa fa-edit"></i></router-link></div>
								</td>
							</tr>
						</template>
						<template v-if="configurationData.length == 0">
							<tr>
								<td colspan="3" align="center">
									<md-empty-state
									  class="table-no-record"
							          md-label="No Record Found"
							          md-description="">
							        </md-empty-state>
								</td>
							</tr>
						</template>
					</md-table>
					<!-- Protopia Owner -->
					<md-table class="member-table" v-if="$route.params.reference == 'protopia-owner'">
						<md-table-row >
							<md-table-head class="card-header">
								<md-checkbox class="checkBox-visible" v-model="checkAll" :value="true" @change="checkAllData()"></md-checkbox>
							</md-table-head>
							<md-table-head class="card-header">Owner Name
								<img src="https://storage.googleapis.com/protopia/app/web/down-arrow.png" v-if="ownerNameSort === 'desc'" @click="sortColumn('asc','ownerName')">
								<img src="https://storage.googleapis.com/protopia/app/web/up-arrow.png" v-if="ownerNameSort === 'asc'" @click="sortColumn('desc','ownerName')">
							</md-table-head>
							<md-table-head class="card-header">Owner Email
								<img src="https://storage.googleapis.com/protopia/app/web/down-arrow.png" v-if="ownerEmailSort === 'desc'" @click="sortColumn('asc','ownerEmail')">
								<img src="https://storage.googleapis.com/protopia/app/web/up-arrow.png" v-if="ownerEmailSort === 'asc'" @click="sortColumn('desc','ownerEmail')">
							</md-table-head>
							<md-table-head class="card-header"> Action </md-table-head>
						</md-table-row>
						<template v-for="(referenceData) in configurationData">
							<tr class="md-table-row" v-bind:key="referenceData._id">
								<td class="md-table-cell">
									<div class="md-table-cell-container"><md-checkbox v-model="singleCheckBox" @change="singleRowCheck()" :value="referenceData._id"></md-checkbox></div>
								</td>
								<td class="md-table-cell"><div class="md-table-cell-container">{{ referenceData.name ? (referenceData.name): '-' }}</div></td>
								<td class="md-table-cell"><div class="md-table-cell-container">{{ referenceData.email ? (referenceData.email): '-' }}</div></td>
								<td class="md-table-cell">
									<div class="md-table-cell-container"><router-link :to="{ path: 'reference-' + $route.params.reference + '/' + referenceData._id + '/edit', params: { reference: $route.params.reference, id: referenceData._id }}" ><i class="fa fa-edit"></i></router-link></div>
								</td>
							</tr>
						</template>
						<template v-if="configurationData.length == 0">
							<tr>
								<td colspan="3" align="center">
									<md-empty-state
									  class="table-no-record"
							          md-label="No Record Found"
							          md-description="">
							        </md-empty-state>
								</td>
							</tr>
						</template>
					</md-table>

					<!-- Wizard Content -->
					<configuration-wizard v-if="$route.params.reference == 'wizard-content'"></configuration-wizard>

					<!-- Interests -->
					<configuration-interests v-if="$route.params.reference == 'interests'"></configuration-interests>
					<!-- Interest end  -->
					<div class="w-100 text-center mt-20" v-if="$route.params.reference != 'interests' && $route.params.reference != 'wizard-content'">
						<md-button class="md-mini btnplain capitalize card-header" v-if="showLoadMore()" @click="loadDataWithApi(searchData)">Load More</md-button>
					</div>
	                <input type="file" accept=".csv" ref="file" @change="handleUpload" id="upload-sheet" style="display: none" />
					<div class="button-section button-section-style" v-if="$route.params.reference != 'interests' && $route.params.reference != 'wizard-content'">
						<md-button class="md-raised md-accent md-white-color capitalize" :disabled="disabledBtn == 1 ? true : false">
							<md-dialog-confirm
							:md-active.sync="allDeleteBtn"
							md-title="Delete Confirmation"
							:md-content="setContentForAllDelete"
							@md-confirm="removeAllRecord" />
							<span class="md-remove md-remove-all" @click="allDeleteBtn = true">Delete All</span>
						</md-button>
						<md-button class="md-raised md-accent md-white-color capitalize" :disabled="disabled == 1 ? true : false">
							<md-dialog-confirm
							:md-active.sync="active"
							md-title="Delete Confirmation"
							:md-content="setContent"
							@md-confirm="removeRecord" />
							<span class="md-remove" @click="active = true">Delete</span>
						</md-button>
						<md-button class="md-raised md-accent md-white-color capitalize" v-if="$route.params.reference != 'protopia-owner' && $route.params.reference != 'wizard-content'"  @click="$refs.file.click()">Load</md-button>
						<a target="_blank" v-bind:href="CSVLink" v-if="$route.params.reference != 'protopia-owner' && $route.params.reference != 'wizard-content'"  title="Download sample file" download>
							<md-button class="md-fab md-mini md-white-color downloadBtn">
								<i class="fa fa-download"></i>
							</md-button>
						</a>
					</div>
				</md-card-content>
            </div>
		</div>
	</div>
</template>
<script>
import API from "../services/API";
import ConfigurationInterests from "./ConfigurationInterests.vue";
import ConfigurationWizard from "./ConfigurationWizard.vue";
import { sanitizeInput } from '../utils/sanitizer';
export default {
	components: {
		ConfigurationInterests,
		ConfigurationWizard
  	},
    data() {
        return {
            fullPage: true,
            api: new API(),
            title: '',
            configurations: ["education", "location", "organization", "roles", "coaching-templates", "skills", "filter-words", "interests", "protopia-owner", "wizard-content"],
            search: null,
			singleCheckBox: [],
            successCount: 0,
    		rejectCount: 0,
    		updateCount: 0,
            configurationData: [],
			getAllData: [],
			searchData: "",
			skipData: 0,
			showTotalRecord: 100,
			showSearchData: 100,
			roleSort: 'desc',
			descriptionSort: 'desc',
			nameSort: 'desc',
			urlSort: 'desc',
			categorySort: 'desc',
			marketSort: 'desc',
			statusSort: 'desc',
			countrySort: 'desc',
			stateSort: 'desc',
			regionSort: 'desc',
			citySort: 'desc',
			latitudeSort: 'desc',
			longitudeSort: 'desc',
			populationSort: 'desc',
			collegeSort: 'desc',
			skillsSort: 'desc',
			wordSort: 'desc',
			interestSort: 'desc',
			ownerNameSort: 'desc',
			ownerEmailSort: 'desc',
			headlineSort: 'desc',
			introductionSort: 'desc',
			contentSort: 'desc',
			closeSort: 'desc',
			checkAll: false,
			totalRecord: 0,
			sampleCSVLinks: ['https://storage.googleapis.com/protopia/app/web/sample-education.csv', 'https://storage.googleapis.com/protopia/app/web/sample-location.csv', 'https://storage.googleapis.com/protopia/app/web/sample-organization.csv', 'https://storage.googleapis.com/protopia/app/web/sample-role.csv', 'https://storage.googleapis.com/protopia/app/web/sample-coachingtemplate.csv', 'https://storage.googleapis.com/protopia/app/web/sample-skills.csv', 'https://storage.googleapis.com/protopia/app/web/sample-filter-word.csv', 'https://storage.googleapis.com/protopia/app/web/sample-interest.csv'],
			CSVLink: '',
			active: false,
			disabled: 1,
			allDeleteBtn: false,
			disabledBtn: 1
        }
    },
	computed: {
		filteredCoachingTemplates() {
			if (this.$route.params.reference === 'coaching-templates') {
				return this.configurationData.filter(item => item.type === 'global');
			}
			return this.configurationData;
		},
    	setContent: function() {
    		return `<strong>Are you sure want to delete?</strong>`
    	},
		setContentForAllDelete: function() {
    		return `<strong>Are you sure want to delete all record?</strong>`
    	}
    },
    watch: {
      $route: "loadData"
    },
    filters: {
        capitalize: function (value) {
			if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
    created() {
        this.loadData();
    },
    methods: {
        loadData: async function() {
			this.singleCheckBox = [];
			this.checkAll = false;
			this.disabledBtn = 1;
			this.totalRecord = 0;
			this.$route.meta.title = 'Reference - ' + this.changeTxt(this.$route.params.reference);
			this.searchData = "";
			this.title = this.$route.params.reference;
			const titleMap = {
				'filter-words': 'Filter Words',
				'protopia-owner': 'Protopia Owners',
				'wizard-content': 'Wizard Content',
				'coaching-templates': 'Coaching Templates'
			};
			if (titleMap[this.$route.params.reference]) {
				this.title = titleMap[this.$route.params.reference];
			}
            if (this.configurations.includes(this.$route.params.reference) === false) {
                this.$router.push('/');
            } else {
				this.disabled = 1;
				var index = this.configurations.indexOf(this.$route.params.reference);
				this.CSVLink = this.sampleCSVLinks[index];
                await this.api.get(`configuration/${this.$route.params.reference}`).then(response => {
                    if (response.status === 200) {
						this.configurationData = response.data.getData;
						this.getAllData = this.configurationData;
						this.totalRecord = response.data.count;
						if (this.totalRecord > 0) {
							this.disabledBtn = 0;
						}
					}
                });
            }
        },
		displayCategory(category) {
			if (category.length > 0) {
				return category.join();
			} else {
				return '-';
			}
		},
		changeTxt(value) {
			if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
		},
        async handleUpload($event) {
    		if ($event.target.files.length) {
				var file = $event.target.files[0];
				if (file.name.split(".").pop() !== 'csv') {
					this.$toast.error('Please select csv file type');
				} else {
                    let reader = new FileReader();
					await reader.readAsText(file, "UTF-8");
                    reader.onload = (evt) => this.getUploadData(evt);
				}
    		}
    	},
        // execute on file readers onload event
    	getUploadData: async function(evt) {
    		var rejectedData = {};
    		rejectedData.list = [];
    		rejectedData.arrIndex = [];
    		rejectedData.message = [];
    		var uploadData = [];
			var results = this.CSVtoArray(evt.target.result, '');
        	// var results = evt.target.result.split("\n");
			// var headers = results[0].split(",");
			var headers = results[0];
			// headers = this.changeHeaders(headers);
            // delete results[0];
			delete results[0];
			if (results.length && results[results.length - 1].length === 1) {
				delete results[results.length - 1];
			}
			var d = results.map((result, outerIndex) => {
				if (result) {
					if (!result) {
						this.rejectCount += 1;
						var arr = [];
						rejectedData.list.push(arr);
						rejectedData.arrIndex.push(outerIndex + 1);
						rejectedData.message.push('Record not found on' + parseInt(outerIndex + 1) + 'row');
					}
					if (result && result.length) {
                        var referenceDetails = this.$lodash.flatten(result).map((cell, index) => {
                            // console.log('headers[index]:cell',headers[index]+':'+cell);
						    if (cell && headers[index] === 'category') {
								cell = cell.split("|").map(c => c.trim());
								cell = cell.filter(v => v !== '');
								return {[headers[index]]: cell};
							} else if (cell) {
                                return {[headers[index]]: cell};
							}
						});
						var reference = referenceDetails.reduce((r, c) => Object.assign(r, c), {});
                        return reference;
					}
				}
			});
			uploadData = d.filter(result => typeof result === 'object');
            this.uploadData(uploadData);
    	},
        CSVtoArray(strData, strDelimiter) {
            // Check to see if the delimiter is defined. If not,
            // then default to comma.
    		strDelimiter = (strDelimiter || ",");
            // Create a regular expression to parse the CSV values.
            var objPattern = new RegExp(
                (
                    // Delimiters.
                    "(\\" + strDelimiter + "|\\r?\\n|\\r|^)" +
                    // Quoted fields.
                    "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +
                    // Standard fields.
                    "([^\"\\" + strDelimiter + "\\r\\n]*))"
                ),
                "gi"
                );
            // Create an array to hold our data. Give the array
            // a default empty first row.
            var arrData = [[]];
            // Create an array to hold our individual pattern
            // matching groups.
            var arrMatches = null;
            // Keep looping over the regular expression matches
    		// until we can no longer find a match.
            while (arrMatches = objPattern.exec(strData)) {
                // Get the delimiter that was found.
                var strMatchedDelimiter = arrMatches[ 1 ];
                // Check to see if the given delimiter has a length
                // (is not the start of string) and if it matches
                // field delimiter. If id does not, then we know
    			// that this delimiter is a row delimiter.
                if (strMatchedDelimiter.length && (strMatchedDelimiter !== strDelimiter)) {
                    // Since we have reached a new row of data,
    				// add an empty row to our data array.
                    arrData.push([]);
                } else if (String(arrMatches['index']) === '0' && arrMatches[1] === ',') {
    				//Check if csv files first field is blank then add blank value to array
    				arrData[ arrData.length - 1 ].push('');
    			}
                // Now that we have our delimiter out of the way,
                // let's check to see which kind of value we
    			// captured (quoted or unquoted).
    			var strMatchedValue = "";
                if (arrMatches[ 2 ]) {
                    // We found a quoted value. When we capture
                    // this value, unescape any double quotes.
                    strMatchedValue = arrMatches[ 2 ].replace(
                        new RegExp("\"\"", "g"),
                        "\""
                        );
                } else {
                    // We found a non-quoted value.
                    strMatchedValue = arrMatches[ 3 ];
    			}
                // Now that we have our value string, let's add
    			// it to the data array.
                arrData[ arrData.length - 1 ].push(strMatchedValue);
            }
    		// Return the parsed data.
            return (arrData);
    	},
        uploadData(data) {
			if (data.length <= 5000) {
				this.api.post(`configuration/${this.$route.params.reference}/csv-import`, {configuration: data})
				.then(response => {
					$("#upload-sheet").val('');
					var referenceMenu = this.$route.params.reference;
					if (this.$route.params.reference === 'filter-words') {
						referenceMenu = 'filter word';
					}
					if (this.$route.params.reference === 'protopia-owner') {
						referenceMenu = 'protopia owners'
					}
					if (this.$route.params.reference === 'wizard-content') {
						this.title = 'Wizard Content'
					}
					this.successCount = response.data.success;
					this.updateCount += response.data.update;
					if (this.successCount > 0 && this.rejectCount > 0 && this.updateCount > 0) {
						this.$toast.success(`${this.successCount} ${referenceMenu} created, ${this.rejectCount} ${referenceMenu} rejected and ${this.updateCount} ${referenceMenu} updated`);
					} else if (this.successCount > 0 && this.updateCount > 0) {
						this.$toast.success(`${this.successCount} ${referenceMenu} created and ${this.updateCount} ${referenceMenu} updated`);
					} else if (this.rejectCount > 0 && this.updateCount > 0) {
						this.$toast.success(`${this.updateCount} ${referenceMenu} updated and ${this.rejectCount} ${referenceMenu} rejected`);
					} else if (this.successCount > 0 && this.rejectCount > 0) {
						this.$toast.success(`${this.successCount} ${referenceMenu} created and ${this.rejectCount} ${referenceMenu} rejected`);
					} else if (this.successCount > 0 && this.rejectCount === 0 && this.updateCount === 0) {
						this.$toast.success(`${this.successCount} ${referenceMenu} created`);
					} else if (this.successCount === 0 && this.updateCount > 0 && this.rejectCount === 0) {
						this.$toast.success(`${this.updateCount} ${referenceMenu} updated`);
					} else if (this.successCount === 0 && this.updateCount === 0 && this.rejectCount > 0) {
						this.$toast.error(`${this.rejectCount} ${referenceMenu} rejected`);
					} else {
						this.$toast.info(`No ${referenceMenu} found`);
					}
					this.successCount = 0;
					this.rejectCount = 0;
					this.updateCount = 0;
					this.loadData();
				}).catch(err => {
					this.$toast.error(`Something went wrong `);
					console.log('err', err);
				});
			} else {
				this.$toast.error(`You are uploading ${data.length} record`);
			}
    	},
		searchDataFromList: function () {
			this.skipData = 0;
			if (this.searchData !== "") {
				var searchParam = this.searchData.toLowerCase();
					this.api.get(`configuration/${this.$route.params.reference}/search-configuration?term=${searchParam}`)
					.then(response => {
						if (response.data.results) {
							this.configurationData = response.data.results;
							this.getAllData = this.configurationData;
						}
					});
			} else {
				this.loadData()
			}
		},
		async sortColumn(sorting, type) {
			if (this.configurationData.length) {
				if (type === 'role') {
					this.roleSort = sorting;
				} else if (type === 'description') {
					this.descriptionSort = sorting;
				} else if (type === 'name') {
					this.nameSort = sorting;
				} else if (type === 'url') {
					this.urlSort = sorting;
				} else if (type === 'category') {
					this.categorySort = sorting;
				} else if (type === 'market') {
					this.marketSort = sorting;
				} else if (type === 'status') {
					this.statusSort = sorting;
				} else if (type === 'country') {
					this.countrySort = sorting;
				} else if (type === 'state') {
					this.stateSort = sorting;
				} else if (type === 'region') {
					this.regionSort = sorting;
				} else if (type === 'city') {
					this.citySort = sorting;
				} else if (type === 'latitude') {
					this.latitudeSort = sorting;
				} else if (type === 'longitude') {
					this.longitudeSort = sorting;
				} else if (type === 'population') {
					this.populationSort = sorting;
				} else if (type === 'college') {
					this.collegeSort = sorting;
				} else if (type === 'skills') {
					this.skillsSort = sorting;
				} else if (type === 'word') {
					this.wordSort = sorting;
				} else if (type === 'interest') {
					this.interestSort = sorting;
				} else if (type === 'ownerEmail') {
					type = 'email';
					this.ownerEmailSort = sorting;
				} else if (type === 'ownerName') {
					type = 'name';
					this.ownerNameSort = sorting;
				} else if (type === 'headline') {
					this.headlineSort = sorting;
				} else if (type === 'introduction') {
					this.introductionSort = sorting;
				} else if (type === 'content') {
					this.contentSort = sorting;
				} else if (type === 'close') {
					this.closeSort = sorting;
				}
				var uri = ''
				if (this.searchData !== "") {
					uri = `configuration/${this.$route.params.reference}/sort-configuration?field=${type}&sortBy=${sorting}&term=${this.searchData.toLowerCase()}`
				} else {
					uri = `configuration/${this.$route.params.reference}/sort-configuration?field=${type}&sortBy=${sorting}`
				}
				await this.api
				.get(uri)
				.then(async response => {
					if (response.data.results) {
						this.configurationData = response.data.results;
						this.getAllData = this.configurationData;
					}
				});
			}
		},
		sanitizeSearchData(value) {
            this.searchData = sanitizeInput(value);
        },
		async loadDataWithApi(searchText) {
			this.checkAll = false;
			if (this.searchData !== "" && searchText.toLowerCase() === this.searchData.toLowerCase()) {
				this.showSearchData += this.showTotalRecord;
				var searchParam = this.searchData.toLowerCase();
				this.skipData += 1;
				await this.api
				.get(`configuration/${this.$route.params.reference}/search-configuration?term=${searchParam}&skip=${this.skipData}`)
				.then(response => {
					if (response.data.results) {
						var getData = this.configurationData.concat(response.data.results);
						this.configurationData = getData;
						this.getAllData = this.configurationData;
					}
				});
			} else {
				this.showSearchData += this.showTotalRecord;
				this.loadConfigurationData()
			}
		},
		loadConfigurationData: async function() {
			this.skipData += 1;
			await this.api
			.get(`configuration/${this.$route.params.reference}/load-configuration?skip=${this.skipData}`)
			.then(async response => {
				if (response.data.results) {
					var getData = this.configurationData.concat(response.data.results);
					this.configurationData = getData;
					this.getAllData = this.configurationData;
				}
			});
		},
		singleRowCheck: function () {
			if (this.singleCheckBox.length > 0) {
				this.disabled = 0;
			} else {
				this.disabled = 1;
			}
			if (this.getAllData.length === this.singleCheckBox.length) {
				this.checkAll = true;
				this.disabled = 0;
			} else {
				this.checkAll = false;
			}
		},
		checkAllData: function() {
			if (this.checkAll) {
				this.disabled = 0;
				var selectRowId = this.getAllData.map((result, outerIndex) => {
					return result._id;
				})
				this.singleCheckBox = selectRowId;
				if (this.singleCheckBox.length === 0) {
					this.disabled = 1;
					this.checkAll = false;
				}
			} else {
				this.singleCheckBox = [];
				this.disabled = 1;
			}
		},
		showLoadMore() {
			if (this.searchData !== "") {
				return this.configurationData.length >= this.showSearchData
			} else {
				return this.configurationData.length < this.totalRecord
			}
		},
		removeRecord: async function() {
			if (this.singleCheckBox.length > 0) {
				await this.api.post(`configuration/${this.$route.params.reference}/delete`, {ids: this.singleCheckBox})
				.then(response => {
					if (response.data.results) {
						this.checkAll = false;
						this.loadData();
						this.$toast.success(`${response.data.results.deletedCount} ${this.$route.params.reference} deleted successfully`);
					}
				});
			} else {
				this.$toast.info(`Please select row`);
			}
		},
		removeAllRecord: async function() {
			if (this.totalRecord > 0) {
				await this.api.post(`configuration/${this.$route.params.reference}/delete-all`, {ids: this.singleCheckBox})
				.then(response => {
					if (response.data.results) {
						this.checkAll = false;
						this.disabledBtn = 1;
						this.loadData();
						this.$toast.success(`${response.data.results.deletedCount} ${this.$route.params.reference} deleted successfully`);
					}
				});
			}
		},
		AddNewFilter: async function() {
			if (this.$route.params.reference == 'filter-words' || this.$route.params.reference == 'protopia-owner' || this.$route.params.reference == 'wizard-content') {
				this.$router.push(`/configuration/${this.$route.params.reference}/add`);
			}
		}
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Configuration.vue